<template>
  <el-dialog title="详情" v-model="visible" :close-on-click-modal="false">
    <el-tabs v-model="activeName" v-loading="loading">
      <el-tab-pane label="详情" name="detail">
        <el-descriptions border :column="2">
          <template v-for="item in description" :key="item.value">
            <el-descriptions-item :label="item.label" width="25%">
              <span
                class="my_class"
                v-if="['category', 'processStatus'].includes(item.value)"
                >{{ formData[item.value]?.desc }}</span
              >
              <span class="my_class" v-else>{{
                formData[item.value] || "-"
              }}</span>
            </el-descriptions-item>
          </template>
        </el-descriptions>

        <el-text type="primary" style="margin-top: 10px; display: inline-block"
          >物料种类：{{ tableData.length }}&nbsp;&nbsp;&nbsp;&nbsp; 数量总数：{{
            getTotal()
          }}</el-text
        >

        <el-table
          :data="tableData"
          style="margin-top: 10px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column label="序号" type="index" width="60" />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <span>{{ row[item.prop] || "-" }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="审核记录" name="records" style="padding: 10px">
        <el-timeline>
          <template v-for="item in records" :key="item.id">
            <el-timeline-item
              :timestamp="item.createTime"
              :type="approvalStatus[item.resultStatus?.value]"
              placement="top"
            >
              <p>
                {{
                  `【${item.approvalUserName}】执行了【${item.resultStatus?.desc}】操作`
                }}
              </p>
              <p v-if="item.resultStatus?.value == 2">
                {{ `驳回理由: ${item.reason}` }}
              </p>
            </el-timeline-item>
          </template>
        </el-timeline>
        <el-empty description="暂无审核记录" v-if="records.length == 0" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import {
  queryApprovalDetailById,
  queryStorageDetailById,
} from "@/api/approval";
import { queryAllotDetailByApprovalId } from "@/api/allot";
import { getProjectApproval } from "@/api/project";

// 弹窗控制器
const visible = ref(false);

// 遮罩
const loading = ref(true);

// 当前tab选中得pane
const activeName = ref("detail");

// 描述列表数据
const formData = ref({});

// 描述列表字段配置
const description = ref([
  {
    label: "审批类型",
    value: "category",
  },
  {
    label: "业务类型",
    value: "typeName",
  },
  {
    label: "创建人",
    value: "createByName",
  },

  {
    label: "状态",
    value: "processStatus",
  },
  {
    label: "修改人",
    value: "updateByName",
  },
  {
    label: "修改时间",
    value: "updateTime",
  },
  {
    label: "执行人",
    value: "dutyUserName",
  },
]);

// 表格列配置
const columns = ref([]);

// 表格数据
const tableData = ref([]);

// 审核记录列表
const records = ref([]);

// 审批状态
const approvalStatus = reactive({
  0: "primary",
  1: "success",
  2: "danger",
});

// 审批类型
const approvalType = reactive({
  1: queryStorageDetailById, // 入库
  2: queryStorageDetailById, // 出库
  4: queryAllotDetailByApprovalId,
  5: getProjectApproval,
  6: getProjectApproval,
  7: queryStorageDetailById, // 出库
});

// 物料列表映射
const materialObj = reactive({
  1: "materialList",
  2: "materialList",
  4: "aiDTOList",
  5: "inventoryList",
  6: "inventoryList",
  7: "materialList",
});

// 弹窗打开
const handleDialogOpen = (row) => {
  activeName.value = "detail";
  initData(row.id);
  visible.value = true;
};

// 获取数据
const initData = (id) => {
  loading.value = true;
  queryApprovalDetailById(id)
    .then((res) => {
      formData.value = res.data;
      records.value = res.data.taskList || [];
    })
    .finally(() => {
      getStorageData(id);
      loading.value = false;
    });
};

// 获取出入库得数据
const getStorageData = (id) => {
  console.log(formData.value?.category?.value, "aaaaaaaaaaaa");
  if (formData.value?.category?.value) {
    approvalType[formData.value?.category?.value](id)
      .then((res) => {
        columns.value = [
          {
            label: "物料名称",
            prop: "materialName",
          },
          {
            label: "编号",
            prop: "number",
          },
          {
            label: "数量",
            prop: "changeQuantity",
          },
          {
            label: "单价",
            prop: "price",
          },
          {
            label: "单位",
            prop: "unit",
          },
        ];
        tableData.value =
          res.data?.[materialObj[formData.value?.category.value]];
        if (formData.value?.category.value == 7) {
          columns.value = [
            {
              label: "物料名称",
              prop: "materialName",
            },
            {
              label: "编号",
              prop: "number",
            },
            {
              label: "数量",
              prop: "applyQuantity",
            },
            {
              label: "单位",
              prop: "unit",
            },
          ];
        }
        if (["5", "6"].includes(formData.value?.category.value)) {
          tableData.value.map((i) => {
            i.changeQuantity = i.number;
            i.warehousePositionName = i.position;
            i.number = i.materialNumber;
            i.unit = i.materialUnit;
          });
        }
        if (formData.value?.category.value == 4) {
          tableData.value.forEach((item) => {
            item.inPosition = res.data.inBoundWarehouse.name;
            item.outPosition = res.data.outBoundWarehouse.name;
            item.number = item.materialDTO.number;
            item.unit = item.materialDTO.unit;
            item.materialName = item.materialDTO.name;
          });
          columns.value = [
            {
              label: "物料名称",
              prop: "materialName",
            },
            {
              label: "出库仓库",
              prop: "outPosition",
            },
            {
              label: "入库仓库",
              prop: "inPosition",
            },
            {
              label: "编号",
              prop: "number",
            },
            {
              label: "数量",
              prop: "quantity",
            },
            {
              label: "单位",
              prop: "unit",
            },
          ];
        }
        // 获取业务类型
        formData.value.typeName = res.data.typeText || "";
      })
      .finally(() => {
        loading.value = false;
      });
  }
};
const getTotal = (id) => {
  let propsName = "";
  switch (formData.value?.category?.value) {
    case "4":
      propsName = "quantity";
      break;

    case "7":
      propsName = "applyQuantity";
      break;

    default:
      propsName = "changeQuantity";
      break;
  }
  let total = tableData.value.reduce(
    (sum, item) => sum + (item[propsName] || 0),
    0
  );
  return total;
};
//  暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
